<template>
  <section class="content-section">
    <div class="container">
      <div class="slider-card-wrapper">
        <SliderCard
          :other-stories="otherStories"
          :hide-social="isTablet"
          social-page-name="story"
        />
      </div>
      <div class="content-wrapper">
        <Social
          class="social social-mobile"
          page-name="story"
        />
        <div
          class="content"
          v-html="storyContent"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderCard from './SliderCard/SliderCard.vue';
import Social from '~/components/Common/Social/Social.vue';
import isTablet from '~/mixins/responsive';

export default {
  components: {
    SliderCard,
    Social,
  },
  mixins: [isTablet],
  props: {
    storyContent: {
      type: String,
      required: true,
    },
    otherStories: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ContentSection.scss';
</style>
